import { fromJS } from 'immutable';

const SET_ERROR = 'error/SET_ERROR';
const SET_MAINTENANCE = 'error/SET_MAINTENANCE';
const CLEAR_ERROR = 'error/CLEAR_ERROR';
/**
 *  reducers
 */
var initialState = fromJS({
  message: '',
  show: false,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
    case SET_MAINTENANCE:
      let newState = state.set('show', true).set('message', action.message);
      if (action.maintenanceMode) {
        newState = newState.set('maintenanceMode', action.maintenanceMode);
      }
      return newState;
    case CLEAR_ERROR:
      return state
        .set('show', false)
        .set('maintenanceMode', false)
        .set('message', '');
    default:
      return state;
  }
};

/**
 *  actions
 */

export function setError(error) {
  return {
    type: SET_ERROR,
    error,
  };
}

export function setMaintenance(error, maintenanceMode) {
  return {
    type: SET_MAINTENANCE,
    error,
    maintenanceMode,
  };
}

export function clearError() {
  return {
    type: CLEAR_ERROR,
  };
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer,
};
